import type { CustomError, MetaSegment } from "@skv/core";

type Website = {
  name: string;
  url: string;
};

export interface Organisation {
  id: number;
  name: string;
  description: string;
  category: string;
  website: Website | null;
  phoneNumber: string;
  managingVRC: string;
  logoUrl: string;
  primaryAddress: PrimaryAddress;
  canonicalUrl: string;
  opportunitySearchUrl: string;
  friendlyName: string;
  totalCount: number;
  opportunities: Opportunity[];
  isSocialEnterprise: boolean;
  agencyNames: string[];
}

interface Opportunity {
  category: MetaSegment<number>;
  friendlyName: string;
  id: number;
  locations: Location[];
  name: string;
  onlineRemoteVolunteers: boolean;
  organisation: OppOrganisation;
  summary: string;
  typesOfWork: MetaSegment<number>[];
  url: string;
}

interface Location {
  suburb: string;
  state: string;
  displayName: string;
  segments: MetaSegment<string>[];
}

interface OppOrganisation {
  logoUrl: string;
  id: number;
  name: string;
  friendlyName: string;
  url: string;
}

interface PrimaryAddress {
  street: string;
  suburb: string;
  state: string;
}

export interface State {
  loading: boolean;
  error: null | CustomError;
  data: {
    [key: string]: Organisation | CustomError;
  };
}

export type ActionTypes =
  | {
      type: "ORGANISATION:FETCH:START";
    }
  | {
      type: "ORGANISATION:FETCH:END" | "ORGANISATION:FETCH:END:FROMCACHE";
      payload: {
        data: Organisation;
      };
    }
  | {
      type: "ORGANISATION:FETCH:ERROR";
      payload: {
        id: string;
        error: CustomError;
      };
    }
  | {
      type: "ORGANISATION:FETCH:ERROR:UNKNOWN";
      payload: {
        error: CustomError;
      };
    }
  | {
      type: "ORGANISATION:ERROR:RESET";
    };

export const reducer = (
  state: State = {
    loading: false,
    error: null,
    data: null,
  },
  action: ActionTypes
): State => {
  switch (action.type) {
    case "ORGANISATION:FETCH:START":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "ORGANISATION:FETCH:END":
    case "ORGANISATION:FETCH:END:FROMCACHE":
      return {
        ...state,
        loading: false,
        error: null,
        data: {
          ...state.data,
          [action.payload.data.id]: action.payload.data,
        },
      };
    case "ORGANISATION:FETCH:ERROR":
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        data: {
          ...state.data,
          [action.payload.id]: action.payload.error,
        },
      };
    case "ORGANISATION:FETCH:ERROR:UNKNOWN":
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case "ORGANISATION:ERROR:RESET":
      return {
        ...state,
        loading: false,
        error: null,
      };
    default:
      return state;
  }
};
